import React from "react"

function LoginForm(props) {
    const { onSubmit, handleInput, errorMessage } = props;

    return (
        <div className="row">
            { errorMessage &&
                <p>{errorMessage}</p>
            }
            <form onSubmit={onSubmit} autoComplete="off" className="col s12">
                <div className="row" style={{display: "flex", alignItems: "center"}}>
                    <div className="input-field col s4">
                        <input
                            id="user_id"
                            name="user_id"
                            type="text"
                            onChange={handleInput}
                            required={true}
                        />
                        <label htmlFor="user_id">UAN ID</label>
                    </div>
                    <div className="input-field col s4">
                        <input
                            id="password"
                            name="password"
                            type="password"
                            onChange={handleInput}
                            required={true}
                        />
                        <label htmlFor="password">UAN Profile Password</label>
                    </div>
                    <div className="col s4">
                        <button className="btn waves-effect waves-light" type="submit" name="action">
                            Login
                            {/* <i className="material-icons right">send</i> */}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default LoginForm;
